import { Component, Inject, Injector } from "@angular/core";
import { WidgetBaseComponent } from "./widgetBase";
import { ReportDesignerWidgetGrowthInfo } from "../models/report-designer-widget-growth-info";
import { DynamicGrowthRowComponent } from "../multipage/dynamic-growth-row/dynamic-growth-row.component";
import { environment } from "../../../../environments/environment";

/**
 * Base class for dynamic widgets
 */
@Component({ template: '' })
export abstract class WidgetDynamicBaseComponent extends WidgetBaseComponent {

  public growthInfo = new ReportDesignerWidgetGrowthInfo();
  public disable = true;

  private dynamicRows: DynamicGrowthRowComponent[] = [];

  constructor(protected injector: Injector, @Inject(String) public name: string, @Inject(Boolean) protected isStatic: boolean) {
    super(injector, name, isStatic);
    this.skipWidgetDataLoadedCall = true;
  }

  /**
   * Based on the amount of columns in the data, each widget can request to be put on a H page if it's alone on a V page
   * @returns true if it could need more columns
   */
  public abstract moreColumnsRequestedIfOnPortraitPage(): boolean;

  public registerGrowthRow(row: DynamicGrowthRowComponent): void {
    this.dynamicRows.push(row);

    if (this.getReport() && this.dynamicRows.length === this.getMaximumRowIndex()) {//For reports ONLY
      this.checkBounds();
    }
  }

  public checkBounds() {
    if (this.widgetConfig.widgetSettings.resizeDataHash !== this.widgetDataHash) {
      for (let i = 0; i < this.dynamicRows.length; ++i) {
        this.dynamicRows[i].measure();
      }

      this.growthInfo.moreColumnsRequestedIfOnPortraitPage = this.page.options.isPortrait && this.widgetConfig.supportsLandscape && this.moreColumnsRequestedIfOnPortraitPage();

      if (this.growthInfo.rowsOutOfBounds.length || this.growthInfo.moreColumnsRequestedIfOnPortraitPage) {
        console.log("Widget " + this.name + " needs more height or width: " + this.growthInfo.additionalHeightNeeded + "px: At least one row overflowed - request the document to split up the pages. Don't call page data loaded");
        if (!environment.disableDynamicWidgets) {
          this.page?.document.requestMoreSpace(this.page, this, this.growthInfo);
          if (this.isStatic) {
            this.ref.markForCheck();
          }
        }

      }
      else {
        console.log("Widget " + this.name + ": All rows fit into the widget's bounds. Call data loaded callback.");
        this.page?.widgetDataLoaded(this.widgetConfig?.widgetSettings.id);
      }
    }
    else {
      console.log("Widget " + this.name + ": Won't resize because data hash matches.");
    }
  }

  public inBounds(rowIndex: number, rowHeightNeeded: number) {
    this.growthInfo.rowsInBounds.push(rowIndex);
    this.growthInfo.rowSizes[rowIndex] = rowHeightNeeded;
  }

  public boundsExceeded(rowIndex: number, rowHeightNeeded: number) {
    this.growthInfo.rowsOutOfBounds.push(rowIndex);
    this.growthInfo.rowSizes[rowIndex] = rowHeightNeeded;
    this.growthInfo.additionalHeightNeeded += rowHeightNeeded;
  }

  public abstract getMaximumRowIndex(): number;

  public getLowerRowIndex(): number {
    if (this.widgetConfig.widgetSettings.lowerRowIndex !== null) {
      return this.widgetConfig.widgetSettings.lowerRowIndex;
    }
    return 1;
  }

  public getUpperRowIndex(): number {
    if (this.widgetConfig.widgetSettings.upperRowIndex !== null) {
      return this.widgetConfig.widgetSettings.upperRowIndex;
    }
    return this.getMaximumRowIndex();
  }
}
